const { registerBlockType } = wp.blocks;
const {
  RichText,
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
  URLInputButton,
} = wp.blockEditor;
const { Button, PanelBody, SelectControl, Icon, ToggleControl } = wp.components;
const { Fragment } = wp.element;
const { __ } = wp.i18n;

import PgButton from '../utils/pg-button';

registerBlockType('pg/products-section', {
  title: __('PG Products Section'),
  icon: 'format-image',
  category: 'layout',
  attributes: {
    sectionClass: {
      type: 'string',
      default: 'section-dark-secondary',
    },
    topEyebrow: {
      type: 'string',
      default: '',
    },
    topHeading: {
      type: 'string',
      default: '',
    },
    columns: {
      type: 'array',
      default: [],
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { sectionClass, topEyebrow, topHeading, columns } = attributes;

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    const addColumn = () => {
      const newColumns = [
        ...columns,
        {
          imgSrc:
            '/wp-content/themes/positiongreen/resources/images/placeholders/placeholder_12.png',
          iconSrc: '',
          imgAltText: '',
          iconAltText: '',
          title: '',
          description: '',
          featuresTitle: '',
          features: [''],
          buttons: [
            {
              link: '#',
              label: 'Learn more',
              buttonClass: 'btn btn-light btn-outline',
            },
          ],
        },
      ];
      setAttributes({ columns: newColumns });
    };

    const removeColumn = (index) => {
      const newColumns = columns.filter((_, i) => i !== index);
      setAttributes({ columns: newColumns });
    };

    const updateColumn = (index, updates) => {
      const newColumns = columns.map((column, i) => {
        if (i === index) {
          return { ...column, ...updates };
        }
        return column;
      });
      setAttributes({ columns: newColumns });
    };

    const onSelectImage = (index, media) => {
      updateColumn(index, { imgSrc: media.url });
    };

    const onSelectIcon = (index, media) => {
      updateColumn(index, { iconSrc: media.url });
    };

    const addFeature = (index) => {
      const newColumns = columns.slice();
      newColumns[index].features.push('');
      setAttributes({ columns: newColumns });
    };

    const removeFeature = (index, featureIndex) => {
      const newColumns = columns.slice();
      newColumns[index].features = newColumns[index].features.filter(
        (_, i) => i !== featureIndex
      );
      setAttributes({ columns: newColumns });
    };

    const updateFeature = (index, featureIndex, value) => {
      const newColumns = columns.slice();
      newColumns[index].features[featureIndex] = value;
      setAttributes({ columns: newColumns });
    };

    const addButton = (index) => {
      const newColumns = columns.slice();
      newColumns[index].buttons.push({
        link: '#',
        label: 'New Button',
        buttonClass: 'btn btn-light btn-outline',
      });
      setAttributes({ columns: newColumns });
    };

    const removeButton = (index, buttonIndex) => {
      const newColumns = columns.slice();
      newColumns[index].buttons = newColumns[index].buttons.filter(
        (_, i) => i !== buttonIndex
      );
      setAttributes({ columns: newColumns });
    };

    const updateButton = (index, buttonIndex, updates) => {
      const newColumns = columns.slice();
      newColumns[index].buttons[buttonIndex] = {
        ...newColumns[index].buttons[buttonIndex],
        ...updates,
      };
      setAttributes({ columns: newColumns });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Section Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass}>
          <div className="products-section">
            <div className="content-container">
              <div className="top">
                <RichText
                  tagName="p"
                  className="h2-eyebrow"
                  value={topEyebrow}
                  onChange={(value) => setAttributes({ topEyebrow: value })}
                  placeholder={__('Enter eyebrow...')}
                />
                <RichText
                  tagName="h2"
                  value={topHeading}
                  onChange={(value) => setAttributes({ topHeading: value })}
                  placeholder={__('Enter heading...')}
                />
              </div>
              <div className="columns-wrapper">
                {columns.map((column, index) => (
                  <div className="column" key={index}>
                    <MediaUploadCheck>
                      <MediaUpload
                        onSelect={(media) =>
                          updateColumn(index, {
                            imgSrc: media.url,
                            imgAltText: media.alt || '',
                          })
                        }
                        allowedTypes={['image']}
                        value={column.imgSrc}
                        render={({ open }) => (
                          <Button
                            onClick={open}
                            isPrimary
                            className={'rightLeftButton'}
                          >
                            {__('Upload Image')}
                          </Button>
                        )}
                      />
                    </MediaUploadCheck>
                    {column.imgSrc && (
                      <img src={column.imgSrc} alt={column.imgAltText} />
                    )}

                    <div className="product-content">
                      <div className={'product-content-top'}>
                        <MediaUploadCheck>
                          <MediaUpload
                            onSelect={(media) =>
                              updateColumn(index, {
                                iconSrc: media.url,
                                iconAltText: media.alt || '',
                              })
                            }
                            allowedTypes={['image']}
                            value={column.iconSrc}
                            render={({ open }) => (
                              <Button
                                onClick={open}
                                isPrimary
                                className={'rightOverTopButton'}
                              >
                                {__('Upload Icon')}
                              </Button>
                            )}
                          />
                        </MediaUploadCheck>
                        {column.iconSrc && (
                          <img
                            src={column.iconSrc}
                            alt={column.iconAltText}
                            className="icon"
                          />
                        )}
                        <RichText
                          tagName="h3"
                          className="title title-sr"
                          value={column.title}
                          onChange={(value) =>
                            updateColumn(index, { title: value })
                          }
                          placeholder={__('Enter title...')}
                        />
                      </div>
                      <div className="description">
                        <RichText
                          tagName="p"
                          value={column.description}
                          onChange={(value) =>
                            updateColumn(index, { description: value })
                          }
                          placeholder={__('Enter description...')}
                        />
                      </div>
                      <div className="features">
                        <RichText
                          tagName="h4"
                          value={column.featuresTitle}
                          onChange={(value) =>
                            updateColumn(index, { featuresTitle: value })
                          }
                          placeholder={__('Enter features title...')}
                        />
                        <ul>
                          {column.features.map((feature, featureIndex) => (
                            <li key={featureIndex}>
                              <RichText
                                tagName="span"
                                value={feature}
                                onChange={(value) =>
                                  updateFeature(index, featureIndex, value)
                                }
                                placeholder={__('Enter feature...')}
                              />
                              <Button
                                isSmall
                                onClick={() =>
                                  removeFeature(index, featureIndex)
                                }
                              >
                                <Icon icon="no-alt" />
                              </Button>
                            </li>
                          ))}
                          <Button isSmall onClick={() => addFeature(index)}>
                            + {__('Add Feature')}
                          </Button>
                        </ul>
                      </div>
                    </div>
                    <div className="buttons">
                      {column.buttons.map((button, buttonIndex) => (
                        <div key={`btnIdx-${buttonIndex}`}>
                          <PgButton
                            link={button.link}
                            label={button.label}
                            buttonClass={button.buttonClass}
                            onUpdate={(object) =>
                              updateButton(index, buttonIndex, object)
                            }
                            onRemove={() => removeButton(index, buttonIndex)}
                            linkField={'link'}
                            labelField={'label'}
                            buttonClassField={'buttonClass'}
                          />
                        </div>
                      ))}
                      <div className={'fullWidth'}>
                        <Button isPrimary onClick={() => addButton(index)}>
                          + {__('Add Button')}
                        </Button>
                      </div>
                    </div>
                    <Button
                      isSmall
                      isDestructive
                      onClick={() => removeColumn(index)}
                    >
                      <Icon icon="trash" /> {__('Remove Column')}
                    </Button>
                  </div>
                ))}
              </div>
              <Button isPrimary onClick={addColumn}>
                + {__('Add Column')}
              </Button>
            </div>
          </div>
        </section>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const { sectionClass, topEyebrow, topHeading, columns } = attributes;

    return (
      <section className={sectionClass}>
        <div className="products-section">
          <div className="content-container">
            <div className="top">
              <RichText.Content
                tagName="p"
                className="h2-eyebrow"
                value={topEyebrow}
              />
              <RichText.Content tagName="h2" value={topHeading} />
            </div>
            <div className="columns-wrapper">
              {columns.map((column, index) => (
                <div className="column" key={index}>
                  {column.imgSrc && (
                    <img src={column.imgSrc} alt={column.imgAltText} />
                  )}
                  <div className="product-content">
                    <div className={'product-content-top'}>
                      {column.iconSrc && (
                        <img
                          src={column.iconSrc}
                          alt={column.iconAltText}
                          className="icon"
                        />
                      )}
                      <RichText.Content
                        tagName="h3"
                        className="title title-sr"
                        value={column.title}
                      />
                    </div>
                    <div className="description">
                      <RichText.Content
                        tagName="p"
                        value={column.description}
                      />
                    </div>
                    <div className="features">
                      <RichText.Content
                        tagName="h4"
                        value={column.featuresTitle}
                      />
                      <ul>
                        {column.features.map((feature, featureIndex) => (
                          <li key={featureIndex}>
                            <RichText.Content value={feature} />
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="buttons">
                    {column.buttons.map((button, buttonIndex) => (
                      <a
                        key={buttonIndex}
                        href={button.link}
                        className={button.buttonClass}
                      >
                        <RichText.Content tagName="span" value={button.label} />
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  },
});
